module.exports = __webpack_public_path__ + "static/media/feature_steak.cce8b858.jpg";